export enum Radii {
	Small = '1px',
	Default = '8px',
	Medium = '24px',
	Big = '100px',
	Circle = '100%'
}
